import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { PublishSuccessModal } from '@/components/ui/PublishSuccessModal';
import { setPublishSuccessHandler } from '@/lib/publishSuccess';

interface PublishSuccessContextType {
  showPublishSuccess: (options?: { title?: string; message?: string; onGoHome?: () => void }) => void;
}

const PublishSuccessContext = createContext<PublishSuccessContextType | undefined>(undefined);

export const usePublishSuccess = () => {
  const context = useContext(PublishSuccessContext);
  if (!context) {
    throw new Error('usePublishSuccess must be used within PublishSuccessProvider');
  }
  return context;
};

interface PublishSuccessProviderProps {
  children: ReactNode;
}

export const PublishSuccessProvider: React.FC<PublishSuccessProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalOptions, setModalOptions] = useState<{
    title?: string;
    message?: string;
    onGoHome?: () => void;
  }>({});

  const showPublishSuccess = (options?: { title?: string; message?: string; onGoHome?: () => void }) => {
    setModalOptions(options || {});
    setIsOpen(true);
  };

  // Register the handler globally so toast system can use it
  useEffect(() => {
    setPublishSuccessHandler(showPublishSuccess);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setModalOptions({});
  };

  return (
    <PublishSuccessContext.Provider value={{ showPublishSuccess }}>
      {children}
      <PublishSuccessModal
        isOpen={isOpen}
        onClose={handleClose}
        onGoHome={modalOptions.onGoHome}
        title={modalOptions.title}
        message={modalOptions.message}
      />
    </PublishSuccessContext.Provider>
  );
};

